export const TaxiService = {
  Standard: 1,
  Elegance: 2,
  Premium: 3,
  First: 4,
  Limousine: 5,
  MiniVan: 6,
} as const;

export type TaxiService = (typeof TaxiService)[keyof typeof TaxiService];

export const TaxiServiceLabel: Record<TaxiService, string> = {
  [TaxiService.Standard]: "Standard",
  [TaxiService.Elegance]: "Elegance",
  [TaxiService.Premium]: "Premium",
  [TaxiService.First]: "First",
  [TaxiService.Limousine]: "Limousine",
  [TaxiService.MiniVan]: "Mini-Van",
};
